import React, { useMemo } from 'react';
import DsModal from '../../DsModal';
import PersonAvatar from '../../avatar/PersonAvatar';
import '../../../../css/common/chat/ChatMessageReactions.css';

const formatReadAt = (value) => {
  if (!value) return '既読時刻不明';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '既読時刻不明';
  const parts = new Intl.DateTimeFormat('ja-JP', {
    timeZone: 'Asia/Tokyo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date);
  const map = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${map.year}/${map.month}/${map.day} ${map.hour}:${map.minute}`;
};

const ChatMessageReadStatusDetailModal = ({
  open = false,
  loading = false,
  readers = [],
  onClose = null,
}) => {
  const renderDisplayName = (displayName, partName) => {
    const normalizedPartName = String(partName || '').trim();
    return (
      <>
        <span>{displayName}</span>
        {normalizedPartName ? (
          <span className="chat-message-reaction-detail-modal__part">（{normalizedPartName}）</span>
        ) : null}
      </>
    );
  };
  const normalizedReaders = useMemo(() => {
    const safeReaders = Array.isArray(readers) ? readers : [];
    return safeReaders.map((reader) => {
      const displayName = String(reader?.displayName || '').trim() || '—';
      const isArtist = reader?.actorType === 'artist';
      const profilePicture = String(reader?.profilePicture || '').trim();
      return {
        ...reader,
        displayName,
        actorType: isArtist ? 'artist' : 'admin',
        gender: reader?.gender || reader?.artist_gender || '',
        profilePicture,
      };
    });
  }, [readers]);

  return (
    <DsModal open={open} onClose={onClose} title="既読状況" size="sm">
      <div className="chat-message-reaction-detail-modal__body">
        {loading ? <div className="chat-message-reaction-detail-modal__empty">読み込み中...</div> : null}
        {!loading && !normalizedReaders.length ? (
          <div className="chat-message-reaction-detail-modal__empty">このメッセージを既読した参加者はいません。</div>
        ) : null}
        {!loading && normalizedReaders.map((reader) => (
          <div key={`${reader.actorType}:${reader.actorId}:${reader.readAt || ''}`} className="chat-message-reaction-detail-modal__row">
            <PersonAvatar
              role={reader.actorType}
              gender={reader.gender}
              name={reader.displayName}
              profilePicture={reader.profilePicture}
              className={`chat-message-reaction-detail-modal__avatar ${reader.profilePicture ? 'has-image' : ''}`}
              variant="proxy"
              size={40}
              ariaHidden
            />
            <div className="chat-message-reaction-detail-modal__info chat-message-read-detail-modal__info">
              <div className="chat-message-read-detail-modal__identity">
                <div className="chat-message-reaction-detail-modal__name">
                  {renderDisplayName(reader.displayName, reader.partName)}
                </div>
                <div className="chat-message-read-detail-modal__time">{formatReadAt(reader.readAt)}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </DsModal>
  );
};

export default ChatMessageReadStatusDetailModal;
